export default __webpack_public_path__ + "static/media/fhusalogo.9dca4c3f.svg";